module.exports = __webpack_public_path__ + "static/pakmaya-sites-9a1c543b3f0722e4c408bf2106d80e92.png";